import { render, staticRenderFns } from "./admin-managers-edit.vue?vue&type=template&id=f348b092&lang=pug&"
import script from "./admin-managers-edit.vue?vue&type=script&lang=js&"
export * from "./admin-managers-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports